module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "flow-doctor-ui",
    "version": "1"
  },
  "pageAction": {
    "name": "pageAction",
    "class": "interaction",
    "properties": {
      "objectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "actionType": {
        "type": [
          "CLICK_REVISION",
          "CLICK_DIAGNOSE",
          "EXPAND_ILS_CRITERIA",
          "EXPAND_CLASSIC_CRITERIA",
          "EXPAND_CLASSIC_REENROLLMENT_CRITERIA",
          "EXPAND_EVENT_CRITERIA",
          "TOGGLE_REVISION_TIMELINE",
          "TOGGLE_LIST_MEMBERSHIP_TIMELINE",
          "TOGGLE_OBJECT_MERGE_TIMELINE",
          "TOGGLE_PROPERTY_CHANGE_TIMELINE",
          "TOGGLE_FORM_SUBMISSION_TIMELINE",
          "TOGGLE_UNIFIED_EVENT_TIMELINE",
          "TOGGLE_FLOW_REVISION_TIMELINE",
          "CLICK_LIST_BRANCH_DEBUG",
          "CLICK_VIEW_EVALUATION",
          "CLICK_CLOSE_FEEDBACK_SURVEY",
          "CHOOSE_NON_ENROLLMENT_OBJECT",
          "SELECT_NON_ENROLLMENT_TIMEFRAME",
          "CLICK_SELECT_NON_ENROLLMENT_ITEM",
          "VIEW_NON_ENROLLMENT_DIAGNOSIS",
          "CLICK_EXPAND_ENROLLMENT_CHECK",
          "CLICK_COLLAPSE_ENROLLMENT_CHECK",
          "CLICK_EXPAND_ALL_ENROLLMENT_CHECKS",
          "CLICK_COLLAPSE_ALL_ENROLLMENT_CHECKS",
          "CLICK_ENROLLMENT_TIMELINE_TAB",
          "CLICK_LIST_BRANCH_HISTORY_TAB",
          "CLICK_ACTIONS_EXPLORER_TAB",
          "CLICK_EXPLORE_ACTIONS",
          "CLICK_EXECUTION_DETAILS",
          "CLICK_NEXT_ATTEMPT",
          "CLICK_PREV_ATTEMPT",
          "CLICK_VIEW_ENROLLMENT_TRACES",
          "CLICK_LEARN_MORE_FORM_ANALYTICS",
          "CLICK_VIEW_ENROLLMENT_HISTORY_LOGS"
        ]
      }
    },
    "namespace": "flow-doctor-ui",
    "version": "1"
  },
  "publishSurvey": {
    "name": "publishSurvey",
    "class": "interaction",
    "properties": {
      "objectId": {
        "type": "number"
      },
      "portalId": {
        "type": "number"
      },
      "flowId": {
        "type": "number"
      },
      "questionId": {
        "type": [
          "HELPFUL_DIAGNOSIS",
          "WHY_NOT_HELPFUL"
        ]
      },
      "responseOption": {
        "type": [
          "YES",
          "NO",
          "MISSING_DETAILS",
          "HARD_TO_UNDERSTAND",
          "INCORRECT_DIAGNOSIS",
          "OTHER"
        ]
      }
    },
    "namespace": "flow-doctor-ui",
    "version": "1"
  }
};